import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserInfoService } from '../services/user-info/user-info.service';
import AuthRoles from '../../assets/data/authRoles.json';

@Injectable()
export class GuardService {

  constructor(
    private readonly _router: Router,
    private readonly userInfoService: UserInfoService
  ) {}

  canActivate(): boolean {
    const isValid = !sessionStorage.getItem('personnes') ? false : true;
    const auth = this.userInfoService.getAuth();

    if (auth?.item.roles.some((r) => AuthRoles.includes(r)) && isValid) {
      return true;
    }

    this._router.navigate(['login']);
    return false;
  }

}
